(() => {
  if (window.__maysaFounderElementBound) return;
  window.__maysaFounderElementBound = true;

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-maysa-founder-trigger]");

    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute("aria-controls"));
      if (dialog?.matches("[data-maysa-founder-dialog]") && !dialog.open) {
        dialog.showModal();
      }
      return;
    }

    const closeButton = event.target.closest("[data-maysa-founder-close]");
    if (closeButton) {
      closeButton.closest("[data-maysa-founder-dialog]")?.close();
      return;
    }

    const dialog = event.target.closest("[data-maysa-founder-dialog]");
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      const clickedInside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!clickedInside) dialog.close();
    }
  });

})();
